export const DOMAIN = '192.0.0.133';
//export const DOMAIN = 'localhost';
export const SELLER_DOMAIN = '181.79.47.50';
export const API_HOST = `http://${DOMAIN}:9001`;
export const API_SELLER_HOST = `http://${SELLER_DOMAIN}:9001`;
export const API_INFO_MANAGER_HOST = `http://${DOMAIN}:8000`;
export const API_PRINTER_HOST = `http://${DOMAIN}:8989`;